export const EventNewBadgeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
      fill="#FB8F44"
    />
    <path
      d="M5 11V5H6.30286L9.10571 8.82286C9.07714 8.57714 9.05429 8.34 9.03714 8.11143C9.02 7.87714 9.00571 7.63143 8.99429 7.37429C8.98857 7.11143 8.98857 6.81429 8.99429 6.48286V5H10.4086V11H9.08857L6.31143 7.25429C6.34 7.53429 6.36 7.76857 6.37143 7.95714C6.38857 8.14 6.4 8.31143 6.40571 8.47143C6.41143 8.62571 6.41429 8.8 6.41429 8.99429V11H5Z"
      fill="white"
    />
  </svg>
);
